import React from 'react';
import { UserPrivacySwitch } from '../../';
import { VStack, Text } from 'native-base';
import { useGetCurrentUserPrivacyStatesQuery } from '@breakroom-nx/redux';

/* eslint-disable-next-line */
export interface UserPrivacySettingsProps {}

export enum TogglePrivacyOption {
  Name,
  Age,
  Location,
  OnlineStatus,
}

export function UserPrivacySettings(props: UserPrivacySettingsProps) {
  const { data: privacyStates, isLoading } =
    useGetCurrentUserPrivacyStatesQuery();

  return (
    <VStack space={8} justifyContent={'flex-start'} flex={1}>
      <Text
        fontFamily={'heading'}
        fontSize={26}
        color={'white'}
        fontWeight={600}
        mb={'3px'}
      >
        Privacy
      </Text>
      <UserPrivacySwitch
        title="Hide my Name"
        description="Prevent users from seeing your real name, your username will be shown instead. Your real name is only displayed on your profile."
        privacyOption={TogglePrivacyOption.Name}
        on={!privacyStates?.showName ?? false}
        disabled={isLoading}
        key={'name'}
      />
      <UserPrivacySwitch
        title="Hide my Age"
        description="Prevent users from seeing my age."
        privacyOption={TogglePrivacyOption.Age}
        on={!privacyStates?.showAge ?? false}
        disabled={isLoading}
        key={'age'}
      />
      <UserPrivacySwitch
        title="Hide my Location"
        description="Prevent users from seeing the city in which you reside. Your country will still be displayed as a flag on your profile."
        privacyOption={TogglePrivacyOption.Location}
        on={!privacyStates?.showLocation ?? false}
        disabled={isLoading}
        key={'city'}
      />
      <UserPrivacySwitch
        title="Hide my Online Status"
        description="Prevent users from seeing if you are online and the last time you were active"
        privacyOption={TogglePrivacyOption.OnlineStatus}
        on={!privacyStates?.showOnlineStatus ?? false}
        disabled={isLoading}
        key={'onlineStatus'}
      />
    </VStack>
  );
}

export default UserPrivacySettings;
